/**
 * Find a matching countryCode in a provided phoneNumber
 */
export const findCountryCode = (countryCodeOptions, phoneNumber) => {
    const startsWithZeroes = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.startsWith('00');
    if (countryCodeOptions && ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.includes('+')) || startsWithZeroes)) {
        const options = countryCodeOptions.filter((code) => startsWithZeroes
            ? phoneNumber.indexOf(`00${code.countryCode || code.value}`) > -1
            : phoneNumber.indexOf(`+${code.countryCode || code.value}`) > -1);
        if (options.length === 0) {
            // no matches found
            return undefined;
        }
        return options.map((val) => val.countryCode || val.value.toString());
    }
    return undefined;
};
